export default "__VITE_ASSET__ihbp9Rad__"